import { useContext, useLayoutEffect, useMemo, useState } from "react";
import useAuth from "../../../../../../Hooks/useAuth";
import CustomizerContext from "../../../../../../_helper/Customizer";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import { InventoryDescriptionTypes } from "../types";
import { toast } from "react-toastify";
import {StatusRow} from "../../../../../Finance/Settings/ReportType/List/ReportTypeList";
import { formatDateWithTimeZone } from "../../../../../../_helper/dateHelper";
import { InventoryClassApi, InventoryDescriptionApi, InventoryGroupApi, InventoryTypeApi } from "../../../../../../api";
import {
  Name,
  Status,
  Description,
  DateCreated,
  DateModified,
  Alias,
  InventoryDescription,
  InventoryGroup,
  InventoryClass,
  InventoryType,
  Code,
} from "../../../../../../Constant";
import { createDropdownField } from "../../../../../../Data/FormField/PublicData";


export default function useInventoryDescription() {
  const { userOrganisationId }: any = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const title = InventoryDescription;
  const [data, setData] = useState<InventoryDescriptionTypes[]>([]);
  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "name",
      name: "name",
      label: Name,
      type: "text",
      value: "",
      required: true,
      colSize: 6,
    },
    {
      id: "description",
      name: "description",
      label: Description,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    },
    {
      id: "is_active",
      name: "is_active",
      label: Status,
      type: "switch",
      value: "1",
      colSize: 6,
    },
  ]);

  const InventoryGroupDropDown = createDropdownField(
      axiosPrivate,
      "administration_inventory_group_id",
      "administration_inventory_group_id",
      InventoryGroup,
      `${InventoryGroupApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  InventoryGroupDropDown.onChange = async (id, updatedFields) => {
      const nextField = updatedFields.find(
          (field: any) => field.id === "administration_inventory_class_id"
      );
      if (nextField) {
        const endPoint = `${InventoryClassApi}?inventory_group_id=${id}`
        await nextField.fetchOptions(id, false, endPoint);
          const updatedFormFields = updatedFields.map((field: any) => {
              if (field.id === "administration_inventory_group_id") {
                  return { ...field, value: id };
              }
              return field;
          });
          setFormFields([...updatedFormFields]);
      }
  };

  const InventoryClassDropDown = createDropdownField(
      axiosPrivate,
      "administration_inventory_class_id",
      "administration_inventory_class_id",
      InventoryClass,
      ``,
      "",
      6
  );

  InventoryClassDropDown.onChange = async (id, updatedFields) => {
      const nextField = updatedFields.find(
          (field: any) => field.id === "administration_inventory_type_id"
      );
      if (nextField) {
        const endPoint = `${InventoryTypeApi}?inventory_class_id=${id}`
        await nextField.fetchOptions(id, false, endPoint);
          const updatedFormFields = updatedFields.map((field: any) => {
              if (field.id === "administration_inventory_class_id") {
                  return { ...field, value: id };
              }
              return field;
          });
          setFormFields([...updatedFormFields]);
      }
  };

  const InventoryTypeDropDown = createDropdownField(
      axiosPrivate,
      "administration_inventory_type_id",
      "administration_inventory_type_id",
      InventoryType,
      ``,
      "",
      6
  );

  async function updateFields() {
      const updatedFields = [InventoryGroupDropDown, InventoryClassDropDown, InventoryTypeDropDown, ...formFields];
      await InventoryGroupDropDown.fetchOptions();
      setFormFields(updatedFields);
  }

  useLayoutEffect(() => {
    updateFields();
  }, []);

  const tableColumns = [
    {
      name: Name,
      selector: (row: (typeof data)[0]) => `${row.name}`,
      sortable: true,
      center: false,
    },
    {
      name: Code,
      selector: (row: (typeof data)[0]) => `${row.code}`,
      sortable: true,
      center: false,
    },
    {
      name: InventoryType,
      selector: (row: (typeof data)[0]) => `${row.administration_inventory_type.name}`,
      sortable: true,
      center: false,
    },
    {
      name: InventoryClass,
      selector: (row: (typeof data)[0]) => `${row.administration_inventory_type.administration_inventory_class.name}`,
      sortable: true,
      center: false,
    },
    {
      name: InventoryGroup,
      selector: (row: (typeof data)[0]) => `${row.administration_inventory_type.administration_inventory_class.administration_inventory_group.name}`,
      sortable: true,
      center: false,
    },
    {
      name: Status,
      selector: (row: (typeof data)[0]) => `${row.is_active}`,
      sortable: true,
      center: true,
      cell: (row: (typeof data)[0]) => StatusRow(row),
    },
    {
      name: DateCreated,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.created_at)}`,
      sortable: false,
      center: false,
    },

    {
      name: DateModified,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.updated_at)}`,
      sortable: false,
      center: false,
    },
  ];
  const { layoutURL } = useContext(CustomizerContext);
  const newBtn = `${process.env.PUBLIC_URL}/administration/settings/inventory/descriptions/create/${layoutURL}`;
  const [loading, setLoading] = useState(true);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<
    (typeof data)[0] | null
  >(null);
  const [editMode, setEditMode] = useState(false);

  const fetchData = () => {
    setLoading(true);
    axiosPrivate
      .get(
        `${InventoryDescriptionApi}?with_trashed=${false}&organisation_id=${userOrganisationId}`
      )
      .then((res) => {
        const response: InventoryDescriptionTypes[] = res.data.data;
        setData(response);

        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useLayoutEffect(() => {
    fetchData();
  }, []);

  //
  const handleEditRec = async (
    id: number | string,
    editRecord: (typeof data)[0] | any
  ) => {
    await axiosPrivate
      .put(`${InventoryDescriptionApi}/${id}`, {
        ...editRecord,
        organisation_id: userOrganisationId,
      })
      .then((_res) => {
        const updatedData = data.map((row) =>
          row.id === selectedRowData!.id ? { ...row, ..._res.data.data } : row
        );
        setData(updatedData);
        toast.success(`${_res.data.data.name} Editted Successfully.`);
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error("Validation Errors");
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
        // throw err;
        toast.error(err.response.message || "Whoops! Something went wrong");
      });
  };
  const handleEdit = (row: (typeof data)[0] | any) => {
    setViewModalOpen(true);
    setEditMode(true);

    row.administration_inventory_group_id = row.administration_inventory_type.administration_inventory_class.administration_inventory_group.id;
    InventoryGroupDropDown.onChange(row.administration_inventory_group_id, formFields);
    
    row.administration_inventory_class_id = row.administration_inventory_type.administration_inventory_class.id;
    InventoryClassDropDown.onChange(row.administration_inventory_class_id, formFields);
    
    row.administration_inventory_type_id = row.administration_inventory_type.id;

    setSelectedRowData(row);
  };
  const memoizedHandleEdit = useMemo(
    () => handleEditRec,
    [data, selectedRowData]
  );

  const handleView = (row: (typeof data)[0]) => {
    setViewModalOpen(true);
    setEditMode(false);
    setSelectedRowData(row);
  };

  return {
    handleView,
    data,
    tableColumns,
    viewModalOpen,
    selectedRowData,
    editMode,
    newBtn,
    title,
    formFields,
    loading,
    setViewModalOpen,
    handleEdit,
    memoizedHandleEdit,
  };
}
